import { useContext } from 'react'
import { SiteType } from '../../openapi'
import { UserContext } from '../user/provider'

/**
 * プレビュー表示可否の純粋な判定。副作用が無いので単体検証しやすい。
 *
 * online / license どちらのサイトのユーザーにも、全環境（本番含む）でプレビューを
 * 表示する。以前の「staging ビルド + `?preview=on` でのみ表示」「online サイト限定」
 * という段階的な絞り込みはいずれも撤去した。
 * ステージ（rb1/rb2）やミッションでは分岐しない。ステージ別・ミッション別の可否は
 * {@link getPreviewDisplayMode} の責務で、ミッション情報取得前が hidden なのも
 * そちらで判定する。
 *
 * siteName 未取得（undefined＝読み込み中）はどちらのサイトか判定できないため非表示。
 */
export const getPreviewVisible = (siteName: SiteType | undefined): boolean =>
  siteName === SiteType.Online || siteName === SiteType.License

/**
 * おためしプレイ（プレビュー）を表示するかどうかを返すフック。
 *
 * HeaderMenu の操作ボタンと editor の PreviewModal をこの結果で同時に切り替え、
 * 表示条件を一元管理する。判定の実体は {@link getPreviewVisible} に委ねる。
 */
export const usePreviewVisible = (): boolean => {
  // isOnlineUser / isLicenseUser は effect 由来の派生 state で 1 レンダー遅れるため、
  // siteName から同期的に判定する（undefined＝読み込み中は非表示）。
  const { siteName } = useContext(UserContext)
  return getPreviewVisible(siteName)
}
